var _circle, _circle2, _circle3, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircles1Faq(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 364,
    viewBox: "0 0 156 364",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 92.4879,
    cy: 190.528,
    r: 36.6899,
    transform: "rotate(-20.8984 92.4879 190.528)",
    stroke: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 1.89744,
    transform: "matrix(-0.934214 0.356712 0.356712 0.934214 70.9452 220.283)",
    fill: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 1.89744,
    transform: "matrix(-0.934214 0.356712 0.356712 0.934214 71.0351 160.941)",
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-12.3893 314.807C56.6031 288.463 91.1768 211.178 64.8334 142.186C38.4899 73.1937 -38.795 38.62 -107.787 64.9634C-176.78 91.3069 -211.353 168.592 -185.01 237.584C-158.667 306.577 -81.3816 341.15 -12.3893 314.807ZM-12.0326 315.741C57.4757 289.201 92.308 211.338 65.7676 141.829C39.2271 72.3211 -38.6358 37.4888 -108.144 64.0292C-177.652 90.5697 -212.485 168.433 -185.944 237.941C-159.404 307.449 -81.5409 342.282 -12.0326 315.741Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircles1Faq);
export default __webpack_public_path__ + "static/media/circles1_faq.b04b9880017d5fc32835e123502f527b.svg";
export { ForwardRef as ReactComponent };